/**
 * MM Hero Marque Manager - Moon Moon Agency
 * Toggle "Voir plus" / "Lire moins" sur le texte tronque (fondu + max-height).
 *
 * Cf. .claude/rules/javascript.md (Manager pattern).
 */

/*********************************************************************************************
 * 🏷️ MM HERO MARQUE MANAGER
 */
const MMHeroMarqueManager = {
	config: {
		selectors: {
			wrap:   '[data-hero-marque]',
			text:   '[data-hero-marque-text]',
			toggle: '[data-hero-marque-toggle]',
		},
		collapsedLines: 4,
	},

	init(root) {
		(root || document).querySelectorAll(this.config.selectors.wrap).forEach(w => this._initWrap(w));
	},

	_initWrap(wrap) {
		const text = wrap.querySelector(this.config.selectors.text);
		const btn = wrap.querySelector(this.config.selectors.toggle);
		if (!text || !btn) return;

		const lineHeight = parseFloat(getComputedStyle(text).lineHeight) || 18;
		const collapsed = lineHeight * this.config.collapsedLines;

		/* Texte assez court : pas de troncature, on masque le bouton */
		if (text.scrollHeight <= collapsed + 2) {
			wrap.classList.remove('is-collapsed');
			btn.hidden = true;
			return;
		}

		text.style.maxHeight = collapsed + 'px';
		wrap.classList.add('is-collapsed');
		btn.hidden = false;

		btn.addEventListener('click', () => {
			const expanded = wrap.classList.toggle('is-expanded');
			if (expanded) {
				text.style.maxHeight = text.scrollHeight + 'px';
				wrap.classList.remove('is-collapsed');
				btn.textContent = btn.dataset.less || 'Lire moins';
				btn.setAttribute('aria-expanded', 'true');
			} else {
				text.style.maxHeight = collapsed + 'px';
				wrap.classList.add('is-collapsed');
				btn.textContent = btn.dataset.more || 'Voir plus';
				btn.setAttribute('aria-expanded', 'false');
			}
		});
	},
};

/*********************************************************************************************
 * 🚀 INIT
 */
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => MMHeroMarqueManager.init());
} else {
	MMHeroMarqueManager.init();
}

/* Re-init quand le Customizer recharge la section */
document.addEventListener('shopify:section:load', (e) => {
	e.target.querySelectorAll('[data-hero-marque]').forEach(wrap => {
		const text = wrap.querySelector('[data-hero-marque-text]');
		if (text) text.style.maxHeight = '';
		wrap.classList.remove('is-expanded', 'is-collapsed');
	});
	MMHeroMarqueManager.init(e.target);
});

window.MMHeroMarqueManager = MMHeroMarqueManager;
